import { InputHTMLAttributes, forwardRef } from "react"

import { cn } from "@/lib/utils"
import { IconSearch } from "@tabler/icons-react"

import { Spinner } from "./Spinner"

export type SearchProps = {
  size?: "small" | "large"
  dark?: boolean
  showLoadingSpinner?: boolean
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size">

export const Search = forwardRef(function Search(
  {
    size = "small",
    placeholder = "Search",
    dark = false,
    className,
    showLoadingSpinner = false,
    ...props
  }: SearchProps,
  ref: React.Ref<HTMLInputElement>,
) {
  return (
    <div
      className={cn(
        className,
        "group relative",
        dark ? "text-center text-white" : "text-grey-500",
        size === "small" ? "text-body2" : "text-body1",
      )}
    >
      <div className="pointer-events-none absolute flex h-full items-center justify-center px-3">
        {showLoadingSpinner && props.disabled ? (
          <Spinner size={14} />
        ) : (
          <IconSearch size={14} />
        )}
      </div>
      <input
        placeholder={placeholder}
        ref={ref}
        className={cn(
          dark &&
            "placeholder-bg-transparent bg-[rgba(255,255,255,0.1)] text-center text-white placeholder-[rgba(255,255,255,0.5)] focus:text-left disabled:placeholder:text-grey-500",
          dark ? "rounded-md border-grey-500" : "rounded-full border-grey-300",
          "w-full py-1 pr-3 pl-10 outline-hidden",
          "border border-solid",
          "group-hover:border-grey-400",
          dark
            ? "group-focus-within:border-colors-border-secondary group-hover:group-focus-within:border-colors-border-secondary"
            : "group-focus-within:border-brand-primary-500 group-hover:group-focus-within:border-brand-primary-500",
        )}
        {...props}
      ></input>
    </div>
  )
})
